import { render, staticRenderFns } from "./ccna2.vue?vue&type=template&id=4a57c0aa"
import script from "./ccna2.vue?vue&type=script&lang=js"
export * from "./ccna2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports